// This file was generated by org.multipaz.processor.CodeBuilder, do not edit by hand
package org.multipaz.wallet.shared

import org.multipaz.cbor.DataItem
import org.multipaz.wallet.shared.Session
import org.multipaz.cbor.Cbor
import kotlinx.io.bytestring.ByteString
import org.multipaz.cbor.annotation.CborSerializableGenerated
import org.multipaz.cbor.CborMap
import org.multipaz.cbor.Tstr
import org.multipaz.cbor.toDataItem
import org.multipaz.wallet.shared.ClientType

fun Session.toCbor(): ByteArray {
    return Cbor.encode(toDataItem())
}

@CborSerializableGenerated(schemaId = "m_ijaNo4QZPbHG9EtRoqqyhK8MvbwE0hRCw376mMr64")
val Session_cborSchemaId = ByteString(-101, -8, -93, 104, -38, 56, 65, -109, -37, 28, 111, 68, -75, 26, 42, -85, 40, 74, -16, -53, -37, -64, 77, 33, 68, 44, 55, -17, -87, -116, -81, -82)

fun Session.Companion.fromCbor(data: ByteArray): Session {
    return Session.fromDataItem(Cbor.decode(data))
}

val Session.Companion.cborSchemaId: ByteString
    get() = Session_cborSchemaId

fun Session.toDataItem(): DataItem {
    val builder = CborMap.builder()
    builder.put("clientId", Tstr(this.clientId))
    builder.put("clientType", Tstr(this.clientType.name))
    builder.put("lastSeenMillis", this.lastSeenMillis.toDataItem())
    val location = this.location
    if (location != null) {
        builder.put("location", Tstr(location))
    }
    val clientDevice = this.clientDevice
    if (clientDevice != null) {
        builder.put("clientDevice", Tstr(clientDevice))
    }
    val clientPlatform = this.clientPlatform
    if (clientPlatform != null) {
        builder.put("clientPlatform", Tstr(clientPlatform))
    }
    return builder.end().build()
}

fun Session.Companion.fromDataItem(dataItem: DataItem): Session {
    val clientId = dataItem["clientId"].asTstr
    val clientType = ClientType.valueOf(dataItem["clientType"].asTstr)
    val lastSeenMillis = dataItem["lastSeenMillis"].asNumber
    val location0 = if (dataItem.hasKey("location")) {
        dataItem["location"].asTstr
    } else {
        null
    }
    val clientDevice0 = if (dataItem.hasKey("clientDevice")) {
        dataItem["clientDevice"].asTstr
    } else {
        null
    }
    val clientPlatform0 = if (dataItem.hasKey("clientPlatform")) {
        dataItem["clientPlatform"].asTstr
    } else {
        null
    }
    return Session(
        clientId = clientId,
        clientType = clientType,
        lastSeenMillis = lastSeenMillis,
        location = location0,
        clientDevice = clientDevice0,
        clientPlatform = clientPlatform0,
    )
}
